import React from 'react';

export default (props) => (
    <svg height="16" viewBox="0 0 10 16" width="10" {...props}>
        <polyline
            fill="none"
            points="2,2 8,8 2,14"
            stroke="#07E"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);
